
import React, { useEffect, useState } from 'react';
import './OurServices.css';
import dryCleaningImg from '../../assets/dryclean.jpg';
import shoeCleaningImg from '../../assets/shoeclean.jpg';
import sofaCleaningImg from '../../assets/sofacleaning.jpg';
import laundryImg from '../../assets/premiumlaundry.jpg';
import menImg from '../../assets/wash&fold.jpg';
import womenImg from '../../assets/wash&iron.jpg';
import householdImg from '../../assets/household.jpg';
import kidsImg from '../../assets/carpetcleaning.jpg';
import tagging from '../../assets/tagging.png';
import treatment from '../../assets/treatment.png';
import prewash from '../../assets/prewash.png';
import washing from '../../assets/washing.png';
import drying from '../../assets/drying.png';
import steamironing from '../../assets/steamironing.jpg';
import ironing from '../../assets/ironing.png';
import Footer from '../Footer';
import FloatingOrderButton from '../../components/FloatingOrderButton';
import PricingSection from './PricingSection';
import { FaCheckCircle, FaLeaf, FaShieldAlt, FaClock, FaStar, FaUsers, FaTag, FaFlask, FaTint, FaWind, FaFire, FaMagic, FaSprayCan, FaSoap, FaTshirt, FaFan, FaThermometerHalf } from 'react-icons/fa';
import { useAppSelector } from '../../store/hooks';

const services = [
    { title: 'Wash & Fold', desc: 'Efficient and tidy wash-and-fold service designed for your daily wardrobe needs.', img: menImg },
    { title: 'Wash & Iron', desc: 'Impeccably clean and crisply ironed clothes delivered straight to your doorstep.', img: womenImg },
    { title: 'Steam Ironing', desc: 'Smooth out wrinkles and refresh clothes with professional steam ironing.', img: steamironing },
    { title: 'Dry-Cleaning', desc: 'Professional care for all your garments — fresh, crisp, and spotless.', img: dryCleaningImg },
    { title: 'Premium Laundry', desc: 'A luxury laundry experience using premium detergents and expert techniques.', img: laundryImg },
    { title: 'Shoe Cleaning', desc: 'Bring your footwear back to life with our expert shoe cleaning and care services.', img: shoeCleaningImg },
    { title: 'Sofa Cleaning', desc: 'Revitalize your sofas and upholstery with deep cleaning and allergen removal.', img: sofaCleaningImg },
    { title: 'Household', desc: 'Complete care for curtains, bedsheets, and more — we handle the heavy loads.', img: householdImg },
    { title: 'Carpet Cleaning', desc: 'Deep-clean carpets and rugs to remove dust, stains, and allergens with ease.', img: kidsImg }
  ];

const laundrySteps = [
    { icon: <FaTag />, title: 'Tagging', desc: 'Clothes are tagged to avoid potential mix up' },
    { icon: <FaMagic />, title: 'Treatment', desc: 'Cuff & collar are treated using special detergents' },
    { icon: <FaSprayCan />, title: 'Pre-Wash', desc: 'Clothes with extra soiling & oil stains are treated to a special enzyme soak before washing' },
    { icon: <FaSoap />, title: 'Washing', desc: 'Clothes are washed as per the load type' },
    { icon: <FaFan />, title: 'Drying', desc: 'Clothes are Air-dried in anti-bacterial stainless-steel dryers' },
    { icon: <FaThermometerHalf />, title: 'Ironing', desc: 'High pressure vacuum steam iron is done for that perfect finishing' },
];
  
  export default function OurServices() {
    const stats = useAppSelector((state) => state.stats);
  
    return (
      <div className="services-page">
         <div className="services-heading">
          <h1 className="tagline">From Wash to Wow!!</h1>
          <h2 className="subtitle">Our Laundry Services</h2>
        </div>
        <div className="services-content">
        <div className="services-grid">
        {services.map((service, idx) => (
          <div key={idx} className="service-card">
            <div className="icon">
              <img src={service.img} alt={service.title} className="service-image" />
            </div>
            <h2>{service.title}</h2>
            <p>{service.desc}</p>
          </div>
        ))}
      </div>
        </div>
        <div className="laundry-process">
          <h2>The Laundry Process</h2>
          <div className="laundry-steps">
            {laundrySteps.map((step, index) => (
              <div className="laundry-step" key={index}>
                <div className="laundry-step-icon">{step.icon}</div>
                <h4>{step.title}</h4>
                <p>{step.desc}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Service Benefits Section */}
        <section className="service-benefits">
          <h2>Why Choose Our Services?</h2>
          <div className="benefits-grid">
            <div className="benefit-card">
              <div className="benefit-icon"><FaCheckCircle /></div>
              <h3>Quality Assured</h3>
              <p>100% satisfaction guarantee with professional cleaning standards and quality checks.</p>
            </div>
            <div className="benefit-card">
              <div className="benefit-icon"><FaLeaf /></div>
              <h3>Eco-Friendly</h3>
              <p>Environmentally conscious cleaning with biodegradable detergents and water-saving techniques.</p>
            </div>
            <div className="benefit-card">
              <div className="benefit-icon"><FaShieldAlt /></div>
              <h3>Safe & Secure</h3>
              <p>Your garments are handled with utmost care and security throughout the entire process.</p>
            </div>
            <div className="benefit-card">
              <div className="benefit-icon"><FaClock /></div>
              <h3>Fast Turnaround</h3>
              <p>Quick service with same-day pickup and next-day delivery options available.</p>
            </div>
          </div>
        </section>

        {/* Service Stats Section */}
        <section className="service-stats">
          <h2>Our Service Excellence</h2>
          <div className="stats-grid">
            <div className="stat-item">
              <div className="stat-number">99.8%</div>
              <div className="stat-label">Customer Satisfaction</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">24hrs</div>
              <div className="stat-label">Average Delivery</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">30K+</div>
              <div className="stat-label">Items Cleaned</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">{stats.storeCount}</div>
              <div className="stat-label">Service Areas</div>
            </div>
          </div>
        </section>

        {/* Service Categories Section */}
        <section className="service-categories">
          <h2>Service Categories</h2>
          <div className="categories-grid">
            <div className="category-card">
              <h3>Basic Services</h3>
              <ul>
                <li>Wash & Fold</li>
                <li>Wash & Iron</li>
                <li>Steam Ironing</li>
              </ul>
            </div>
            <div className="category-card">
              <h3>Premium Services</h3>
              <ul>
                <li>Dry Cleaning</li>
                <li>Premium Laundry</li>
                <li>Specialty Cleaning</li>
              </ul>
            </div>
            <div className="category-card">
              <h3>Home Services</h3>
              <ul>
                <li>Sofa Cleaning</li>
                <li>Carpet Cleaning</li>
                <li>Household Items</li>
              </ul>
            </div>
            <div className="category-card">
              <h3>Specialty Services</h3>
              <ul>
                <li>Shoe Cleaning</li>
                <li>Leather Care</li>
                <li>Wedding Attire</li>
              </ul>
            </div>
          </div>
        </section>

        <PricingSection></PricingSection>
        <Footer />
        <FloatingOrderButton />
      </div>
    );
  }
